<template>
  <bita-modal :id="modalId" :title="title" :modal-lg="true">
    <div slot="body">
      <div class="row" v-if="this.dataView.id">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>نوع بار</label>
            <input class="form-control" :value="this.dataView.load_data.name" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>نوع ماشین</label>
            <input class="form-control" :value="this.dataView.vehicle_type.name" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>تعداد</label>
            <input class="form-control" :value="this.dataView.count" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>مبدا</label>
            <input class="form-control" :value="this.dataView.origin.name" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>مقصد</label>
            <input class="form-control" :value="this.dataView.destination.name" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>تاریخ ایجاد</label>
            <input class="form-control" :value="this.$getJalaliDateTime(this.dataView.created_at)" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>تاریخ بارگیری</label>
            <input class="form-control" :value="this.$getJalaliDateTime(this.dataView.lading_date)" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>تاریخ تحویل</label>
            <input class="form-control" :value="this.$getJalaliDateTime(this.dataView.delivery_date)" disabled />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>توضیحات</label>
            <textarea class="form-control" :value="this.dataView.tools" disabled />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    title: {},
    propsData: {
      type: Object,
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.onSubmit(this.dataView);
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    },
  },
  data() {
    return {
      colWidth: "col-lg-4",
      dataView: {},
    };
  },
  watch: {
    propsData: function (_data) {
      this.dataView = _data;
    },
  },
};
</script>
